import ListLandingsScreen from './containers/listLandingsScreen'

export {default as ListLandingsScreenLayout} from './components/listLandingsScreenLayout'

export default ListLandingsScreen
